var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewDocumentOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 24,
    height: 24,
    rx: 4,
    fill: "white",
    stroke: "#1756E8",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6667 7H8.33333C7.6 7 7.00667 7.6 7.00667 8.33333L7 17.6667C7 18.4 7.6 19 8.33333 19H17.6667C18.4 19 19 18.4 19 17.6667V8.33333C19 7.6 18.4 7 17.6667 7ZM17 14.3333H14.3333V17H11.6667V14.3333H9V11.6667H11.6667V9H14.3333V11.6667H17V14.3333Z",
    fill: "#1756E8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewDocumentOutline);
export default __webpack_public_path__ + "static/media/newDocumentOutline.35b6d5c8396b6a48d4259de49c10a9c9.svg";
export { ForwardRef as ReactComponent };